import React, { useState } from "react";
import GlassCard from "./GlassCard";
import howItWorksSteps from "../data/howItWorks";
import Img1 from "../images/step-1.png";
import Img2 from "../images/body-img-2.png";
import Img3 from "../images/video-img.png";
import Img4 from "../images/form-img-2.png"

const images = [Img1, Img2, Img3, Img4]

const HowItWorks = ({ lang = "sl" }) => {
  // 1) pick the list for the current language
  const steps = howItWorksSteps[lang] || howItWorksSteps.sl;

  // 2) local index, bounded by steps.length
  const [index, setIndex] = useState(0);
  const step = steps[index];

  const go = (direction) => {
    setIndex((prev) => {
      const next = direction === "next" ? prev + 1 : prev - 1;
      if (next < 0) return steps.length - 1;
      if (next >= steps.length) return 0;
      return next;
    });
  };

  const heading =
    lang === "en" ? "How Revimo Works" : "Kako deluje Revimo";
  const intro =
    lang === "en"
      ? "Get clear video-based therapy you can follow from home, without scheduling live sessions."
      : "Prejmite pregleden video program vaj, ki jih lahko izvajate doma – brez dogovarjanja za termine s fizioterapevtom.";

  return (
    <section>
      <div className="container" style={{ maxWidth: 1040 }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: 8,
            color: "#176B87",
            fontSize: 28,
          }}
        >
          {heading}
        </h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: 32,
            color: "var(--text-main)",
            maxWidth: 720,
            marginInline: "auto",
          }}
        >
          {intro}
        </p>

        <GlassCard
          style={{
            borderRadius: 32,
            padding: "28px 28px 24px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr)",
              gap: 24,
              alignItems: "center",
            }}
          >
            {/* image placeholder */}
            <div
              style={{
                 width: "450px",
                height: "250px",
                overflow: "hidden",
                borderRadius: "25px"
              }}
            >
            <img src={images[index]} style={{ width: "100%", height: "100%",  objectFit: "cover", objectPosition: "center"}}/>
            </div>

            {/* text + controls */}
            <div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#176B87",
                  marginBottom: 6,
                }}
              >
                Step {index + 1} of {steps.length}
              </div>
              <h3
                style={{
                  marginTop: 0,
                  marginBottom: 10,
                  fontSize: 22,
                }}
              >
                {step.title}
              </h3>
              <p
                style={{
                  marginTop: 0,
                  marginBottom: 20,
                  color: "var(--text-muted)",
                }}
              >
                {step.description}
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                }}
              >
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    onClick={() => go("prev")}
                    style={circleButtonStyle}
                    aria-label="Previous step"
                  >
                    ‹
                  </button>
                  <button
                    onClick={() => go("next")}
                    style={circleButtonStyle}
                    aria-label="Next step"
                  >
                    ›
                  </button>
                </div>

                {/* dots: map over steps, not howItWorksSteps */}
                <div style={{ display: "flex", gap: 6 }}>
                  {steps.map((s, i) => (
                    <span
                      key={s.id}
                      style={{
                        width: i === index ? 22 : 8,
                        height: 8,
                        borderRadius: 999,
                        backgroundColor:
                          i === index ? "#176B87" : "rgba(255,255,255,0.8)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </GlassCard>
      </div>
    </section>
  );
};

const circleButtonStyle = {
  width: 36,
  height: 36,
  borderRadius: 999,
  backgroundColor: "rgba(255,255,255,0.9)",
  boxShadow: "0 10px 20px rgba(0,0,0,0.16)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 22,
  color: "var(--text-main)",
};

export default HowItWorks;
